// extracted by mini-css-extract-plugin
export default {"heading":"m4yEdYbCk4LoomctvqCZ"};